// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ugtxj","value":"styles_value__ACAl4","copy":"styles_copy__VPZ88","copied":"styles_copied__2cQkJ"};